export default __webpack_public_path__ + "static/ay-glossary-havent-found-intercom-6887bdbeb090d43a204ff76d10ff7da1.svg";